module.exports = __webpack_public_path__ + "assets/img/CUA-Social-Static-Ad-w720.557a307a.png";